import { Component, Input } from '@angular/core';
import { Store } from '@ngneat/elf';

@Component({
  selector: 'app-operation-envelope-results',
  templateUrl: './operation-envelope-results.component.html',
  styles: [':host { display: flex; flex-direction: column; flex: 1 1 0%; min-height: 0; overflow: hidden; }'],
  standalone: false
})
export class OperationEnvelopeResultsComponent {
  @Input() public selectedSingleMultiple = 'singleOperation';
  @Input() public selectedResultsDisplay = 'plot';

  @Input() public tableName = 'Operation Envelope';
  @Input() public resultsGrid: any[] = [];
  @Input() public cols: any[] = [];

  @Input() public plotData: any[] = [];
  @Input() public xAxisTitle = '';
  @Input() public yAxisTitle = '';
  @Input() public plotName = '';
  @Input() public downloadPlotName = 'operation_envelope_plot';
  @Input() public operationEnvelopeStore!: Store;

  public shouldShowGrid(): boolean {
    return this.selectedSingleMultiple === 'singleOperation' && this.selectedResultsDisplay !== 'plot';
  }

  public shouldShowPlot(): boolean {
    return this.selectedResultsDisplay === 'plot' && this.plotData.length > 0;
  }
}
